import type { SVGProps } from 'react';

const SvgColorTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="url(#ColorTicket_svg__a)"
      d="M24 4.33a6.334 6.334 0 0 1 6.334 6.334v1.63c0 .755-.527 1.3-1.095 1.496a2.335 2.335 0 0 0 0 4.414c.568.196 1.094.741 1.095 1.495v1.631A6.334 6.334 0 0 1 24 27.664H8a6.334 6.334 0 0 1-6.333-6.334V19.7c0-.755.526-1.3 1.094-1.496a2.335 2.335 0 0 0 0-4.414c-.568-.196-1.094-.741-1.094-1.495v-1.63A6.334 6.334 0 0 1 8 4.33z"
    />
    <path
      fill="#fff"
      d="M15.468 11.37a.667.667 0 0 1 1.064 0l1.32 1.749c.08.106.19.185.315.228l2.071.716c.419.144.583.65.33 1.012l-1.256 1.796a.67.67 0 0 0-.12.37l-.04 2.19a.667.667 0 0 1-.861.626l-2.096-.638a.67.67 0 0 0-.389 0l-2.096.638a.667.667 0 0 1-.86-.625l-.041-2.191a.67.67 0 0 0-.12-.37l-1.255-1.796a.667.667 0 0 1 .328-1.012l2.072-.716a.67.67 0 0 0 .314-.228z"
    />
    <defs>
      <linearGradient
        id="ColorTicket_svg__a"
        x1={16}
        x2={16}
        y1={4.33}
        y2={27.664}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#839DEB" />
        <stop offset={1} stopColor="#9BB2F6" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgColorTicket;
